import React, { useState } from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import PrintIcon  from '@mui/icons-material/Print';
import { useTranslate } from "src/locales";

interface ByzPrintButtonWithTextProps extends React.ComponentProps<typeof Button> {
  onClick?: () => void;
  link?: string;
  popup?: boolean;
}

const StyledButton = styled(Button)<{ popup?: boolean }>(({ popup }) => ({
  borderRadius: popup ? "20px" : "4px",
      padding: "4px 20px",
    gap: "4px",
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "row",
  border: "1px solid #2979C3",
  backgroundColor: "#63B4FF33",
  color: "#2979C3",
  "&:hover": {
    backgroundColor: "#2979C3",
    color: "#fff",
  },
}));

const ByzPrintButtonWithText: React.FC<ByzPrintButtonWithTextProps> = ({ onClick, link, popup }) => {
  const { t } = useTranslate();
  const [hover, setHover] = useState(false);

  const buttonContent = (
    <>
      <PrintIcon
        style={{
          width: "16px",
          height: "16px",
          marginRight: "5px",
          transition: "0.2s ease-in-out",
          
        }}
      />
      <ByzMuiTypography
        fontWeight={400}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "5px",
        }}
      >
        {t("print.print")}
      </ByzMuiTypography>
    </>
  );

  return link ? (
    <Link to={link} style={{ textDecoration: "none" }}>
      <StyledButton
        popup={popup}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {buttonContent}
      </StyledButton>
    </Link>
  ) : (
    <StyledButton
      popup={popup}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {buttonContent}
    </StyledButton>
  );
};

export default ByzPrintButtonWithText;
